import { injectIntl } from "react-intl";
import { intlShape } from "../../shapes";

type Props = {
  id?: string;
  translationKey?: string;
  icon?: string;
  label?: string;
  value?: string;
  intl: intlShape;
  breakValue?: boolean;
};

export function DetailsHeaderItem({
  id,
  translationKey,
  label,
  value,
  intl,
  icon,
  breakValue,
}: Props) {
  const displayLabel =
    label || (translationKey && intl.formatMessage({ id: translationKey }));
  const displayIcon = icon ? (
    <span data-testid="details-item-icon" className={icon} />
  ) : null;
  return (
    <div id={id} className="details-header-item">
      <div className="details-item-name">{displayLabel}</div>
      <div
        className={
          breakValue ? "details-item-value break-all" : "details-item-value"
        }
      >
        {displayIcon} {value ?? "-"}
      </div>
    </div>
  );
}

export default injectIntl(DetailsHeaderItem);
